// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const DownChevron = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 256 256" {...props}>
		<path d="M225.813 48.907 128 146.72 30.187 48.907 0 79.093l128 128 128-128z" />
	</svg>
);
export default DownChevron;
